import { ComponentRef, Type } from '@angular/core';

export class V2BottomSheetContainer<T> {
  protected componentRef?: ComponentRef<T>;
  childComponentType?: Type<T>;
  slideOutCommenced: boolean = false;

  async slideOut(): Promise<void> {}
}
